module.exports = __webpack_public_path__ + "static/media/FAQs.7ee18ac3.svg";